const readMoreContainers = document.querySelectorAll(".ari-read-more-content");

if (readMoreContainers.length) {
	readMoreContainers.forEach((container) => {
		const containerHeight = container.getBoundingClientRect().height;

		if (containerHeight > 1000) {
			container.classList.add("read-more-effect");
			const btn = document.createElement("div");
			btn, (btn.className = "link-btn-container");
			const innerContainer = container.querySelector("& > .e-con-inner");

			btn.innerHTML = `<button class="link-btn down-arrow" style="color:var(--e-global-color-text);"><span>Read more</span></button>`;
			container.appendChild(btn);

			btn.addEventListener("click", (e) => {
				e.preventDefault();

				container.classList.toggle("read-more-effect--expanded");
				if (container.classList.contains("read-more-effect--expanded")) {
					btn.querySelector("span").innerText = "Read less";
				} else {
					btn.querySelector("span").innerText = "Read more";
				}
			});
		}
	});
}
